export type BidDecision = "QUALIFIED" | "REJECTED" | null;

export const verdictReopensDecision = (decided: BidDecision, next: boolean | null): boolean => {
  if (decided === null) return false;
  if (next === null) return true;
  return decided === "QUALIFIED" ? next === false : next === true;
};
